import constant from '../config/index.json';

const STORAGE_KEYS = {
  STORE_NAME: 'StoreName',
  CUSTOMER_CURRENCY: 'customerDefaultCurrency',
};
const getFromStorage = (key, fallback = '') =>
  localStorage?.getItem(key) || fallback;

export const getCurrentStore = () =>
  getFromStorage(STORAGE_KEYS.STORE_NAME);

export const isAPAC = () =>
  getCurrentStore() === constant?.storeName?.APAC;

export const isEU = () =>
  getCurrentStore() === constant?.storeName?.EU;

export const isUS = () =>
  getCurrentStore() === constant?.storeName?.US;

export const isUkUser = (orgId, country) =>
  isEU() &&
  country === 'GB' &&
  (constant?.orgId?.EU?.GB?.ids || []).includes(String(orgId));

export const isFranceUser = (orgId, country) =>  
  isEU() &&
  country === 'FR' &&
  (constant?.orgId?.EU?.FR?.ids || []).includes(String(orgId));

export const isBelgiumUser = (orgId, country) =>  
  isEU() &&
  country === 'BE' &&
  (constant?.orgId?.EU?.BE?.ids || []).includes(String(orgId));  

export const isNetherlandsUser = (orgId, country) =>  
  isEU() &&
  country === 'NL' &&
  (constant?.orgId?.EU?.NL?.ids || []).includes(String(orgId));    

export const getCurrency = (currency) =>
  currency || getFromStorage(STORAGE_KEYS.CUSTOMER_CURRENCY);